import { fetcher } from '#lib/backendFetcher';

/**
 * Fetches the settings and profile data of the logged-in user.
 * @returns {Promise<{data: Object|null, error: Error|null}>}
 */
export const fetchUserSettings = async () => {
	try {
		const data = await fetcher('/api/v1/platform/users/me');
		return { data, error: null };
	} catch (err) {
		return { data: null, error: err };
	}
};

/**
 * Updates the settings of the logged-in user. Throws the backend error so the mutation's
 * rollback and the global error toast run.
 * @param {Object} params
 * @param {Object} params.updates - Object with the fields to change
 * @returns {Promise<void>}
 */
export const updateUserSettings = async ({ updates }) => {
	await fetcher('/api/v1/platform/users/me', {
		method: 'PATCH',
		body: updates,
	});
};
